import React, {useEffect, useState, useRef} from 'react';
import '../App.css';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import Bodyheaderloged from './bodyheaderloged'
import Axios from 'axios';
import { useNavigate } from "react-router-dom";
import Boxbackoffice from './boxbackoffice'
import Boxcliente from './boxcliente'
import Grillabeneficiarios from './grillabeneficiarios'
import Grillacltickest from './grillacltickets'
import Calendar from './calendar'
import io from 'socket.io-client';

function Bodyhome (){
    const navigate = useNavigate();
    const months = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const currentMonthIni = new Date().getMonth();
    const [admBeneficiario, setAdmBeneficiario] = useState();
    const [admBenefBool, setAdmBenefBool] = useState(false);
    const [beneficiarios, setBeneficiarios] = useState([]);
    const [ticketEstado, setTicketEstado] = useState();
    const [ticketDetail, setTicketDetail] = useState([]);
    const [ticketDetailPage, setTicketDetailPage] = useState([]);
    const [pagadosNoConsumidos, setPagadosNoConsumidos] = useState()
    const [pagadosConsumidos, setPagadosConsumidos] = useState()
    const [noPagadosConsumidos, setNoPagadosConsumidos] = useState()
    const [show, setShow] = useState(false);
    const [paginasBeneficiario, setPaginasBeneficiario] = useState()

    const [totalTicketConsumidos, setTotalTicketConsumidos] = useState()
    const [totalTicketPagados, setTotalTicketPagados] = useState()
    const [cantidadTicketConsumidos, setCantidadTicketConsumidos] = useState()
    const [cantidadTicketPagados, setCantidadTicketPagados] = useState()
    
    const [cantidadUsuariosAltaMes, setCantidadUsuariosAltaMes] = useState()
    const [cantidadUsuariosBajaMes, setCantidadUsuariosBajaMes] = useState()


    const [perfil, setPerfil] = useState()
    const [rut, setRut] = useState()
    const [primer_nombre, setprimer_nombre] = useState()
    const [segundo_nombre, setsegundo_nombre] = useState()
    const [primer_apellido, setprimer_apellido] = useState()
    const [segundo_apellido, setsegundo_apellido] = useState(false)
    const [mes, setMes] = useState(currentMonthIni)

    const [events, setEvents] = useState([]);
    const [socketId, setSocketId] = useState('');
    const [socket, setSocket] = useState(null);



    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const searchInput = useRef();

    let statuscall = '' 
    
    const handleChangeMes = (e) => {
        setMes(e.target.value)
    }

    const handleEstadoBenef = (id) => {
        console.log(id)
    }

    const handleChangeprimernombre= (e) => {
        setprimer_nombre(e.target.value)
    }

    const handleChangesegundonombre= (e) => {
        setsegundo_nombre(e.target.value)
    }    

    const handleChangeprimerapellido= (e) => {
        setprimer_apellido(e.target.value)
    }    

    const handleChangesegundoapellido= (e) => {
        setsegundo_apellido(e.target.value)
    }
    
    const handleChangeRut=(e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
        
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
    
        // Formatear RUN
        setRut(cuerpo + '-'+ dv)
    }

    const createBenefificiario = async (e) =>{
        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
        const data = {   
            rut: rut,    
            primer_nombre: primer_nombre,
            segundo_nombre: segundo_nombre,
            primmer_apellido: primer_apellido,
            segundo_apellido: segundo_apellido,
            mail: mailstr.replace('"','')
        };

        const beneficiarioCreate = await Axios.post(process.env.REACT_APP_CREATEBENEF, data, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                
            if(statuscall.status == 200)
            {
                beneficiarios.push(data);
                let copibenef = beneficiarios 
                setBeneficiarios(copibenef)
                handleClose()
                navigate('/Home/' + authcode.replace('"', ''))

            }
            else
            {
                //setAlertHead(statuscall.data.MessageCode)
                //setAlertBody(statuscall.data.Message)
                //setAlertActivate(true)
                //setTimeout(() => {
                    //setAlertActivate(false)
                //}, 5000)
            }      
    }

    const beneficiarioList = Array.isArray(beneficiarios) && beneficiarios.length > 0
    ? beneficiarios.map((item, i)=> ( 
    <tr key={i}>
        <td className='columnaOculta'>{item.id}</td>
        <td>{item.primer_nombre} {item.segundo_nombre}</td>
        <td>{item.primer_apellido} {item.segundo_apellido}</td>
        <td>{item.estado}</td>
        <td><Button onClick={() => handleEstadoBenef(item.id)}>Cambia Estado</Button></td>
    </tr>))
    : (
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );

    const ticketDetailList = Array.isArray(ticketDetail) && ticketDetail.length > 0
    ? ticketDetail.map((item, i) => (
    <tr key={i}>
        <td>{item.beneficiario_fullname}</td>
        <td>{item.fecha_pago}</td>
        <td>{item.fecha_consumo}</td>
        <td>{item.estado_consumo}</td>
        <td>{item.estado_pago}</td>
    </tr>))
    :(
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );






    const getOrdenes = async () =>{

    }
    const getData = async () =>
    {
        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idcasinostr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        
        let mail = mailstr.replace('"', '')
        let idperfil = idperfilstr.replace('"', '')
        let idcasino = idcasinostr.replace('"', '')
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;

        setPerfil(idperfil.replace('"', ''))

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                mail: mail, 
                id_perfil: idperfil, 
                id_casino: idcasino,
                mes: Number(mes) + 1 || currentMonth
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            if(idperfil === "2")
            {
                setTotalTicketConsumidos(response.data.ticket.TotalTicketConsumidos)
                setTotalTicketPagados(response.data.ticket.TotalTicketPagados)
                setCantidadTicketConsumidos(response.data.ticket.CantidadTicketConsumidos)
                setCantidadTicketPagados(response.data.ticket.CantidadTicketPagados)
                setCantidadUsuariosAltaMes(response.data.usuarios.CantidadUsuariosAltaMes)
                setCantidadUsuariosBajaMes(response.data.usuarios.CantidadUsuariosBajaMes)
            }
            else
            {    
                setBeneficiarios(response.data.beneficiarios)
                setTicketDetail(response.data.ticket_detail)
                setPagadosNoConsumidos(response.data.ticket.ticketPagadosNoConsumidos)
                setPagadosConsumidos(response.data.ticket.ticketPagadosConsumidos)
                setNoPagadosConsumidos(response.data.ticket.ticketNoPagadosConsumidos)
                //searchInput.current.focus();
            }
        }).catch(error => {
            return error     
        })   
    }

    const getComandaCliente = async () =>{
        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let user_id = mailstr.replace('"', '')
        

        Axios.get(process.env.REACT_APP_URLGETCOMANDACLIENTE, {
            params: {
                user_id: user_id
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setEvents(response.data.formattedResponse)
        }).catch(error => {
            return error     
        })        
    }

    useEffect(() => {
        const newSocket = io(process.env.REACT_APP_URLSOCKETIO, {
            transports: ['websocket']
        });
    
        
    
        newSocket.on('connect', () => {
            console.log('Socket conectado con ID:', newSocket.id);
            setSocket(newSocket);
            setSocketId(newSocket.id);
            guardaSession(newSocket.id)
        });
        return () => newSocket.disconnect();
    }, []);

    useEffect(() => {  
        getData()
        getComandaCliente()
        //Enviar el socket a la base de datos junto con los 
        //parametros de perfil
    }, [mes])



    const admBenef = (e) =>{
        if(admBenefBool)
        {
            setAdmBeneficiario('bodyhomeBeneficiariosAdmHidden')
            setAdmBenefBool(false)
        }
        else
        {
            setAdmBeneficiario('bodyhomeBeneficiariosAdm')
            setAdmBenefBool(true)
        }
    }

	const guardaSession = (socketid) => {
        const normalizeStorageValue = (key) => {
            const rawValue = window.localStorage.getItem(key);
            return rawValue == null ? '' : rawValue.replace(/"/g, '');
        };

        let user = normalizeStorageValue('MY_APP_STATE_USER');
		let casino = normalizeStorageValue('MY_APP_STATE_PROF_CASINO_ID');
        let tiene_impresora = normalizeStorageValue('MY_APP_STATE_PROF_TIENE_IMPRESORA');
        let impresora = normalizeStorageValue('MY_APP_STATE_PROF_IMPRESORA');
        console.log(user.replace('"', ''))
        console.log(casino)
        console.log(tiene_impresora)
        console.log(impresora)
        console.log(socketid)
        const sessionData = {
            mail: user.replace('"', ''),
            casino_id: casino.replace('"', ''),
            socket_id: socketid,
            tiene_impresora: tiene_impresora.replace('"', ''),
            impresora: impresora.replace('"', '')
        };

        // Realizar la solicitud POST a la API /Session
        Axios.post(process.env.REACT_APP_URLPOSTSESSION, sessionData, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
			   console.log("Session guardada")	
            }
        })
        .catch(error => {
            console.error('Error al enviar la session:', error);
            const errorMessage = error.response?.data?.error 
        });
    };

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged/>
            </div>
            <div className='flex justify-start w-full'>
            { perfil === "2" ?
                <div className="w-full p-6">
                    <div className="mb-8">
                        <h2 className="text-xl font-medium text-gray-600 mb-4 text-center">Seleccione Mes</h2>
                        <select
                            id="month"
                            value={mes}
                            onChange={handleChangeMes}
                            className="p-2 border border-gray-300 rounded-md text-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                        >
                        {months.map((month, index) => (
                        <option key={index} value={index}>
                            {month}
                        </option>
                        ))}
                        </select>                        
                    </div>
                    <div className="mb-8">
                        <h2 className="text-xl font-medium text-gray-600 mb-4 text-center">Totales por estado en $</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                                <Boxbackoffice key={1} titulo={'Total Tickets Pagados'}
                                                    contenido={totalTicketPagados}
                                                    pie={'Mes en curso'}
                                                    signo={'$ '} />
            
                                <Boxbackoffice key={2} titulo={'Total Tickets Consumidos'}
                                                    contenido={totalTicketConsumidos}
                                                    pie={'Mes en curso'}
                                                    signo={'$ '} />
                             
        
                            </div>
                    </div>
                 
        
                    <div className="mb-8">
                        <h2 className="text-xl font-medium text-gray-600 mb-4 text-center">Totales por cantidad</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                <Boxbackoffice key={3} titulo={'Cantidad Tickets Pagados'}
                                                   contenido={cantidadTicketPagados}
                                                   pie={'Mes en curso'}
                                                   signo={'Q '} />
        
                                <Boxbackoffice key={4} titulo={'Cantidad Tickets Consumidos'}
                                                   contenido={cantidadTicketConsumidos}
                                                   pie={'Mes en curso'}
                                                   signo={'Q '} />                                
                            </div>                            
                    </div>
                            
        
                    <div className="mb-8">
                        <h2 className="text-xl font-medium text-gray-600 mb-4 text-center">Novedades por usuario</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                         
                                        <Boxbackoffice key={5} titulo={'Usuarios dados de alta'}
                                                    contenido={cantidadUsuariosAltaMes}
                                                    pie={'Mes en curso'}
                                                    signo={'Q '} />
        
                                        <Boxbackoffice key={6} titulo={'Usuarios dados de baja'}
                                                    contenido={cantidadUsuariosBajaMes}
                                                    pie={'Mes en curso'}
                                                    signo={'Q '} />
                            </div>                           
                    </div>
                </div>
                :
                <div className="w-full">                
                    <div className="w-full">
                        <Grillabeneficiarios/>
                    </div>

                    <div className="w-full p-6">                        
                        <div className="mb-8"> 
                            <div className="bg-white shadow-lg p-6 mx-4 mb-2">
                                <h2 className="text-xl font-semibold mb-4">Estado Tickets</h2>
                            </div>                                                       
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                                <Boxcliente key={10} titulo={'Pagados/No consumidos'}
                                           contenido={pagadosNoConsumidos}
                                           pie={'Historico'}
                                           signo={'Q '} />

                                <Boxcliente key={11} titulo={'Pagados/Consumidos'}
                                           contenido={pagadosConsumidos}
                                           pie={'Historico'}
                                           signo={'Q '} />

                                <Boxcliente key={12} titulo={'No Pagados/Consumidos'}
                                           contenido={noPagadosConsumidos}
                                           pie={'Historico'}
                                           signo={'Q '} />
                            </div>
                        </div>
                    </div>

                    <div className="w-full">
                        <Grillacltickest/>
                    </div>

                    <div className="w-full">
                        <div className='w-full'>
                            <div className="bg-white shadow-lg p-6 mx-4 mb-2">
                                <h2 className="text-xl font-semibold mb-4">Agendamiento de ordenes de cafeteria</h2>
                            </div>

                            {/* Zona 2 */}
                            <div className="bg-white shadow-lg p-4 mx-4 mb-2">                        
                                <Calendar events={events} setEvents={setEvents}/>
                            </div>
                        </div>
                    </div>    

                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                        <Modal.Title>Crea un beneficiario</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div className='row'>
                            <div className='col col-lg-4'>
                                Rut                                                                    
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' value={rut} onChange={handleChangeRut}></input>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                                Primer Nombre                                                                    
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' onChange={handleChangeprimernombre}></input>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                                Segundo Nombre
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' onChange={handleChangesegundonombre}></input>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                                Primer Apellido        
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' onChange={handleChangeprimerapellido}></input>                 
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col col-lg-4'>
                                Segundo Apellido     
                            </div>
                            <div className='col col-lg-4'>
                                <input type='text' onChange={handleChangesegundoapellido}></input>
                            </div>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button onClick={handleClose}>
                            Cerrar
                        </Button>
                        <Button onClick={createBenefificiario}>
                            Crear
                        </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
            </div>
        </div>            
    )
}
export default Bodyhome
